import { useAuth } from '@clerk/clerk-react'
import { useMemo } from 'react'
import { createApiFetcher, createRawApiFetcher } from '@/lib/api'

/**
 * React hook that returns an authenticated API fetcher.
 * Must be used within a ClerkProvider.
 */
export function useApi() {
  const { getToken } = useAuth()
  return useMemo(() => createApiFetcher(getToken), [getToken])
}

/**
 * React hook that returns an authenticated raw fetcher, for endpoints that
 * return a file instead of the JSON envelope (e.g. GET /leads/export).
 * Must be used within a ClerkProvider.
 */
export function useRawApi() {
  const { getToken } = useAuth()
  return useMemo(() => createRawApiFetcher(getToken), [getToken])
}
